/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Away_Brave_Flamingo_ZipInputs */

const es_away_brave_flamingo_zip = /** @type {(inputs: Away_Brave_Flamingo_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesion`)
};

const gl_away_brave_flamingo_zip = /** @type {(inputs: Away_Brave_Flamingo_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const en_away_brave_flamingo_zip = /** @type {(inputs: Away_Brave_Flamingo_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

/**
* | output |
* | --- |
* | "Login" |
*
* @param {Away_Brave_Flamingo_ZipInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const away_brave_flamingo_zip = /** @type {((inputs?: Away_Brave_Flamingo_ZipInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Away_Brave_Flamingo_ZipInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_away_brave_flamingo_zip(inputs)
	if (locale === "en") return en_away_brave_flamingo_zip(inputs)
	return es_away_brave_flamingo_zip(inputs)
});